import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Comment } from '../../models/comment';
@Injectable()
export class CommentService {
  constructor(private http: ApiClient) {}

  create(commentModel) {
    return this.http.post<Comment>('comments', commentModel);
  }
}
